/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_DisplayInputs */

const de__field_display = /** @type {(inputs: _Field_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigeart`)
};

/**

* @param {_Field_DisplayInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_display = /** @type {((inputs?: _Field_DisplayInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_DisplayInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_display(inputs)
});